
(function(){
  'use strict';
  var KEY='thepanelcraft:clone-preview:cart:v1';
  var themeId='189341335806';
  var updatedEvent='pc:preview-cart-changed';
  function normalise(rows){
    if(!Array.isArray(rows))return [];
    var unique={};
    rows.forEach(function(x){
      if(!x||typeof x.code!=='string'||!/^(?:(?:WPC|PVC|AC)-\d{3}|PVC-S-\d{3})$/.test(x.code))return;
      var minQty=/^PVC-00[134]$/.test(x.code)?2:1;
      var qty=Math.min(999,Math.max(minQty,Math.floor(Number(x.qty)||minQty)));
      var price=Number(x.price);
      if(!Number.isFinite(price)||price<0||price>100000)return;
      var image=typeof x.image==='string'&&x.image.indexOf('https://cdn.shopify.com/')===0?x.image:'';
      unique[x.code]={code:x.code,title:String(x.title||x.code).slice(0,200),price:price,image:image,qty:qty};
    });
    return Object.keys(unique).map(function(code){return unique[code];});
  }
  function get(){try{return normalise(JSON.parse(localStorage.getItem(KEY)||'[]'));}catch(e){return [];}}
  function save(rows){
    try{localStorage.setItem(KEY,JSON.stringify(normalise(rows)));}catch(e){return false;}
    document.dispatchEvent(new CustomEvent(updatedEvent,{detail:{items:get()}}));
    return true;
  }
  function count(){return get().reduce(function(n,x){return n+x.qty;},0);}
  function add(item,qty){
    if(!item||!/^(?:(?:WPC|PVC|AC)-\d{3}|PVC-S-\d{3})$/.test(String(item.code||'')))return false;
    var current=get(), match=current.find(function(x){return x.code===item.code;});
    var minQty=/^PVC-00[134]$/.test(item.code)?2:1;
    qty=Math.max(minQty,Math.min(999,Math.floor(Number(qty)||minQty)));
    if(match){
      return remove(item.code);
    }
    current.push({code:String(item.code),title:String(item.title),price:Number(item.price),image:String(item.image),qty:qty});
    return save(current);
  }
  function setQuantity(code,qty){
    var rows=get();qty=Math.floor(Number(qty)||0);
    if(qty<=0)return remove(code);
    var current=rows.find(function(x){return x.code===code;});
    if(!current)return false;
    var minQty=/^PVC-00[134]$/.test(code)?2:1;
    current.qty=Math.max(minQty,Math.min(999,qty));
    return save(rows);
  }
  function remove(code){return save(get().filter(function(x){return x.code!==code;}));}
  function refreshHeader(){
    var link=document.getElementById('cart-icon-bubble');if(!link)return;
    var realCount=Number(link.getAttribute('data-pc-real-count')||0);
    var badge=link.querySelector('[data-pc-preview-count]');
    // When Shopify has buyable catalogue products, never replace the real bag
    // with stale browser-only preview items from an earlier development session.
    if(document.body && document.body.dataset.pcLiveProducts==='true'){
      if(badge)badge.remove();
      if(link.hasAttribute('data-pc-original-href')){
        link.setAttribute('href',link.getAttribute('data-pc-original-href'));
        link.removeAttribute('data-pc-original-href');
      }
      return;
    }
    if(realCount>0){
      if(badge)badge.remove();
      return;
    }
    var number=count();
    if(number<1){
      if(badge)badge.remove();
      if(link.hasAttribute('data-pc-original-href')){
        link.setAttribute('href',link.getAttribute('data-pc-original-href'));
        link.removeAttribute('data-pc-original-href');
      }
    }else{
      if(!badge){
        badge=document.createElement('div');
        badge.className='cart-count-bubble pc-preview-cart-badge';
        badge.setAttribute('data-pc-preview-count','');
        var amount=document.createElement('span');amount.setAttribute('aria-hidden','true');
        var label=document.createElement('span');label.className='visually-hidden';
        badge.append(amount,label);link.append(badge);
      }
      badge.firstElementChild.textContent=number<100?String(number):'99+';
      badge.lastElementChild.textContent=number+' items in preview basket';
      if(!link.hasAttribute('data-pc-original-href'))link.setAttribute('data-pc-original-href',link.getAttribute('href'));
      link.setAttribute('href','/cart?preview_theme_id='+themeId);
    }
    document.querySelectorAll('[data-pc-preview-count-display]').forEach(function(el){el.textContent=String(number);});
  }
  function syncPreviewButtons(){
    var basket=get();
    document.querySelectorAll('[data-pc-wpc-card],[data-pc-pvc-card],[data-pc-wpc-detail],[data-pc-pvc-detail],[data-pc-shower-card],[data-pc-shower-detail],[data-pc-acoustic-card],[data-pc-acoustic-detail]').forEach(function(root){
      var code=root.dataset.pcPreviewCode||root.dataset.pcWpcDetail||root.dataset.pcPvcDetail||root.dataset.pcShowerDetail||root.dataset.pcAcousticDetail;
      var btn=root.querySelector('[data-pc-wpc-card-add],[data-pc-pvc-card-add],[data-pc-preview-add],[data-pc-pvc-add],[data-pc-shower-card-add],[data-pc-shower-add],[data-pc-acoustic-card-add],[data-pc-acoustic-add]');
      if(!code||!btn)return;
      var added=basket.some(function(item){return item.code===code;});
      var wasAdded=btn.classList.contains('is-added');
      btn.classList.toggle('is-added',added);
      btn.setAttribute('aria-pressed',added?'true':'false');
      btn.textContent=added?'✓ Added to Cart':'Add to Cart →';
      if(wasAdded&&!added){
        var message=root.querySelector('[data-pc-wpc-card-feedback],[data-pc-pvc-card-feedback],[data-pc-added-feedback],[data-pc-pvc-detail-feedback],[data-pc-shower-card-feedback],[data-pc-shower-feedback],[data-pc-acoustic-card-feedback],[data-pc-acoustic-feedback]');
        if(message)message.textContent='Product removed from your Shopping Bag';
      }
    });
  }
  document.addEventListener(updatedEvent,function(){setTimeout(syncPreviewButtons,0);});
  document.addEventListener('DOMContentLoaded',syncPreviewButtons);
  document.addEventListener('shopify:section:load',syncPreviewButtons);
  window.addEventListener('storage',function(e){if(e.key===KEY)syncPreviewButtons();});
  if(document.readyState!=='loading')setTimeout(syncPreviewButtons,0);
  window.PCPreviewCart={key:KEY,get:get,add:add,setQuantity:setQuantity,remove:remove,save:save,count:count};
  document.addEventListener(updatedEvent,refreshHeader);
  document.addEventListener('DOMContentLoaded',refreshHeader);
  window.addEventListener('storage',function(event){if(event.key===KEY)refreshHeader();});
  if(document.readyState!=='loading')refreshHeader();
})();


/* PC_SHARED_ACTIONS_V2_20261019 */
(function(){
'use strict';
var themeId='189341335806',storageKey='thepanelcraft:favourites:v1',detailsKey='thepanelcraft:favourites:details:v1',favChanged='pc:favourites-changed';
function money(n){return '£'+(Number(n)||0).toFixed(2)}
function items(){try{return window.PCPreviewCart?window.PCPreviewCart.get():[]}catch(e){return []}}
function getFav(){try{var a=JSON.parse(localStorage.getItem(storageKey)||'[]');return Array.isArray(a)?a:[]}catch(e){return []}}

function getFavDetails(){
 try{var m=JSON.parse(localStorage.getItem(detailsKey)||'{}');return m&&typeof m==='object'&&!Array.isArray(m)?m:{}}catch(e){return {}}
}
function saveFavDetails(identity,root,info){
 var data=getFavDetails(),heading=info.querySelector('h1')||root.querySelector('h1');
 var photo=root.querySelector('.pc-wpc-detail__stage img,.pc-pdp__gallery img,.pc-pdp__media img,img[data-main]');
 data[identity.id]={
   title:String((heading&&heading.textContent)||root.dataset.pcPreviewTitle||identity.id).trim().slice(0,190),
   url:identity.url,
   image:String(root.dataset.pcPreviewImage||(photo&&(photo.currentSrc||photo.src))||'').slice(0,1200)
 };
 try{localStorage.setItem(detailsKey,JSON.stringify(data))}catch(e){}
}
function fallbackFavourite(id){
 var prefix='/collections/',p='?preview_theme_id='+themeId,code=encodeURIComponent(id);
 if(/^WPC-[0-9]{3}$/.test(id))return {title:id,url:prefix+'wpc-wall-panels'+p+'&wpc_preview='+code};
 if(/^PVC-S-[0-9]{3}$/.test(id))return {title:id,url:prefix+'pvc-shower-panels'+p+'&pvc_s_preview='+code};
 if(/^PVC-[0-9]{3}$/.test(id))return {title:id,url:prefix+'pvc-panels'+p+'&pvc_preview='+code};
 if(/^AC-[0-9]{3}$/.test(id))return {title:id,url:prefix+'all'+p+'&pc_category=acoustic&acoustic_preview='+code};
 if(id.indexOf('product:/products/')===0)return {title:id.slice(9).split('/').pop().replace(/-/g,' '),url:id.slice(8)};
 return {title:id,url:prefix+'all'+p};
}
function safeFavouriteUrl(candidate,fallback){
 try{
  var url=new URL(candidate||fallback,location.origin);
  if(url.origin!==location.origin)return fallback;
  if(url.pathname.indexOf('/products/')!==0&&url.pathname.indexOf('/collections/')!==0)return fallback;
  return url.pathname+url.search+url.hash;
 }catch(e){return fallback}
}
function syncFavouriteHearts(){
 var values=getFav();
 document.querySelectorAll('.pc-shared-heart[data-pc-fav-id]').forEach(function(heart){
   var on=values.includes(heart.dataset.pcFavId);
   heart.textContent=on?'♥':'♡';
   heart.setAttribute('aria-pressed',on?'true':'false');
   heart.title=on?'Remove from favourites':'Save to favourites';
 });
}
function renderFavourites(){
 var shell=document.querySelector('[data-pc-fav-shell]');if(!shell)return;
 var favourites=getFav(),details=getFavDetails();
 var badge=shell.querySelector('[data-pc-fav-count]'),list=shell.querySelector('[data-pc-fav-items]'),empty=shell.querySelector('[data-pc-fav-empty]');
 badge.hidden=favourites.length===0;
 badge.textContent=favourites.length>99?'99+':String(favourites.length);
 badge.setAttribute('aria-label',favourites.length+' saved favourites');
 empty.hidden=favourites.length>0;
 list.replaceChildren();
 favourites.forEach(function(id){
   var fallback=fallbackFavourite(id),known=details[id]||{},row=document.createElement('div');
   row.className='pc-fav-header__item';
   var link=document.createElement('a');link.className='pc-fav-header__product';
   link.href=safeFavouriteUrl(known.url,fallback.url);
   var safeImage=null;
   if(typeof known.image==='string'&&known.image){
     try{var u=new URL(known.image,location.origin);if(u.origin===location.origin||u.hostname==='cdn.shopify.com')safeImage=u.toString()}catch(e){}
   }
   if(safeImage){
     var img=document.createElement('img');img.src=safeImage;img.alt='';img.width=54;img.height=61;img.loading='lazy';link.appendChild(img);
   }else{
     var pic=document.createElement('span');pic.className='pc-fav-header__placeholder';pic.textContent='♡';pic.setAttribute('aria-hidden','true');link.appendChild(pic);
   }
   var info=document.createElement('span');info.className='pc-fav-header__product-text';
   var title=document.createElement('strong');title.textContent=String(known.title||fallback.title).slice(0,190);
   var sku=document.createElement('small');sku.textContent=id.indexOf('product:')===0?'View product':id;
   info.append(title,sku);link.appendChild(info);
   var remove=document.createElement('button');remove.type='button';remove.className='pc-fav-header__remove';remove.textContent='×';
   remove.setAttribute('aria-label','Remove '+title.textContent+' from favourites');
   remove.addEventListener('click',function(){
     try{localStorage.setItem(storageKey,JSON.stringify(getFav().filter(function(code){return code!==id})))}catch(e){return}
     document.dispatchEvent(new Event(favChanged));
   });
   row.append(link,remove);list.appendChild(row);
 });
}
function mountFavouritesHeader(){
 var shell=document.querySelector('[data-pc-fav-shell]');if(!shell)return;
 var trigger=shell.querySelector('[data-pc-fav-toggle]'),panel=shell.querySelector('[data-pc-fav-panel]');
 if(trigger&&panel&&!shell.dataset.pcFavBound){
   shell.dataset.pcFavBound='1';
   function close(){panel.hidden=true;trigger.setAttribute('aria-expanded','false')}
   trigger.addEventListener('click',function(){renderFavourites();panel.hidden=!panel.hidden;trigger.setAttribute('aria-expanded',String(!panel.hidden))});
   shell.querySelector('[data-pc-fav-close]').addEventListener('click',function(){close();trigger.focus()});
   document.addEventListener('click',function(e){if(!shell.contains(e.target))close()});
   document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!panel.hidden){close();trigger.focus()}});
 }
 renderFavourites();
}
document.addEventListener(favChanged,function(){renderFavourites();syncFavouriteHearts()});
window.addEventListener('storage',function(e){if(e.key===storageKey||e.key===detailsKey){renderFavourites();syncFavouriteHearts()}});

function infoFor(root){
 var id=root.dataset.pcWpcDetail||root.dataset.pcPvcDetail||root.dataset.pcShowerDetail||root.dataset.pcAcousticDetail||('product:'+location.pathname);
 var url=new URL(location.href);
 if(root.dataset.pcWpcDetail){url.searchParams.set('preview_theme_id',themeId);url.searchParams.set('wpc_preview',id);url.searchParams.delete('pvc_preview')}
 else if(root.dataset.pcPvcDetail){url.searchParams.set('preview_theme_id',themeId);url.searchParams.set('pvc_preview',id);url.searchParams.delete('wpc_preview')}
 else if(root.dataset.pcShowerDetail){url.pathname='/collections/pvc-shower-panels';url.searchParams.set('preview_theme_id',themeId);url.searchParams.set('pvc_s_preview',id);url.searchParams.delete('pvc_preview');url.searchParams.delete('wpc_preview')}
 if(root.dataset.pcAcousticDetail){url.pathname='/collections/all';url.searchParams.set('preview_theme_id',themeId);url.searchParams.set('pc_category','acoustic');url.searchParams.set('acoustic_preview',id);url.searchParams.delete('pc_filter')}
 url.hash='';
 return {id:id,url:url.toString()};
}
function makeLink(text,url){var a=document.createElement('a');a.href=url;a.textContent=text;return a}
function createUI(){
 if(document.getElementById('pc-shared-ui-css'))return;
 var st=document.createElement('style');st.id='pc-shared-ui-css';st.textContent=
 '.pc-shared-heart{margin-left:10px;min-width:52px;height:50px;background:#fff;color:#294d35;border:1px solid #aebfb0;border-radius:5px;font-size:28px;cursor:pointer;vertical-align:middle}' +
 '.pc-shared-heart[aria-pressed=true]{color:#b62d52;background:#fff1f5;border-color:#e6acba}' +
 '.pc-shared-share{min-width:52px;height:50px;margin-left:9px;border:1px solid #aebfb0;border-radius:5px;background:#fff;color:#294d35;font:700 25px Arial,sans-serif;cursor:pointer;vertical-align:middle}' +
 '.pc-shared-actions{display:flex;gap:18px;align-items:center;flex-wrap:wrap;margin:12px 0 15px;padding:13px 0 0;border-top:1px solid #dce4db;font:600 13px/1.5 Arial,sans-serif}' +
 '.pc-shared-actions a,.pc-shared-actions button{color:#2b5038;text-decoration:underline;text-underline-offset:3px;border:0;background:none;padding:0;font:inherit;cursor:pointer}' +
 '.pc-shared-copy-status{margin:0 0 10px;font:12px/1.4 Arial,sans-serif;color:#2b603c}' +
 '.pc-shared-cart-toast{box-sizing:border-box;position:fixed;z-index:999999;top:85px;right:14px;width:min(360px,calc(100vw - 28px));border:1px solid #c5d4c4;border-radius:9px;background:#fff;color:#2a392d;padding:22px;box-shadow:0 16px 43px #0003;font:14px/1.5 Arial,sans-serif;display:none}' +
 '.pc-shared-cart-toast.is-open{display:block}.pc-shared-cart-close{position:absolute;right:10px;top:5px;font-size:26px;background:transparent;border:0;cursor:pointer}' +
 '.pc-shared-cart-title{font-size:19px;font-weight:700;margin:0 0 14px}.pc-shared-cart-row{display:flex;justify-content:space-between;margin:9px 0;gap:20px}' +
 '.pc-shared-cart-checkout{display:block;text-align:center;background:#294d35!important;color:#fff!important;border-radius:4px;padding:11px;margin-top:18px;font-weight:700;text-decoration:none}' +
 '@media(max-width:640px){.pc-shared-cart-toast{top:auto;bottom:12px}}';
 document.head.appendChild(st);
}
function productActions(root){
 var row=root.querySelector('.pc-wpc-detail__buy,.pc-pdp__buy-row');
 var info=root.querySelector('.pc-wpc-detail__information,.pc-pdp__details');
 if(!row||!info||row.querySelector('.pc-shared-heart'))return;
 var identity=infoFor(root),heart=document.createElement('button');heart.type='button';heart.className='pc-shared-heart';heart.setAttribute('aria-label','Toggle favourite');heart.dataset.pcFavId=identity.id;
 function drawHeart(){var has=getFav().includes(identity.id);heart.textContent=has?'♥':'♡';heart.setAttribute('aria-pressed',has?'true':'false');heart.title=has?'Remove from favourites':'Save to favourites'}
 heart.addEventListener('click',function(){var a=getFav(),idx=a.indexOf(identity.id);if(idx>=0)a.splice(idx,1);else{a.push(identity.id);saveFavDetails(identity,root,info)}try{localStorage.setItem(storageKey,JSON.stringify(a))}catch(e){}drawHeart();document.dispatchEvent(new Event(favChanged))});
 row.appendChild(heart);drawHeart();
 var old=info.querySelector('.pc-wpc-detail__cartlink');if(old)old.hidden=true;
 var actions=document.createElement('div');actions.className='pc-shared-actions';
 var isPreview=root.hasAttribute('data-pc-wpc-detail')||root.hasAttribute('data-pc-pvc-detail')||root.hasAttribute('data-pc-shower-detail')||root.hasAttribute('data-pc-acoustic-detail');
 var bag=makeLink('View Shopping Bag →',isPreview?'/cart?preview_theme_id='+themeId:'/cart');
 var share=document.createElement('button');share.type='button';share.className='pc-shared-share';share.textContent='↗';share.setAttribute('aria-label','Share product');share.title='Share product';
 var state=document.createElement('p');state.className='pc-shared-copy-status';state.setAttribute('role','status');
 share.addEventListener('click',async function(){
  var link=infoFor(root).url;
  try{
   if(navigator.share){await navigator.share({title:document.title,url:link});return}
   if(navigator.clipboard){await navigator.clipboard.writeText(link);state.textContent='Product link copied';return}
  }catch(e){if(e.name==='AbortError')return}
  var input=document.createElement('input');input.value=link;document.body.appendChild(input);input.select();
  try{state.textContent=document.execCommand('copy')?'Product link copied':link}catch(e){state.textContent=link}input.remove();
 });
 row.appendChild(share);actions.append(bag);
 var after=info.querySelector('.pc-pvc-preview__detail-feedback,.pc-wpc-detail__added,.pc-pdp__help,[data-pc-shower-feedback],[data-pc-acoustic-feedback]');
 (after||row).insertAdjacentElement('afterend',actions);
 actions.insertAdjacentElement('afterend',state);
}
function toast(count,total,real,removed){
 var el=document.querySelector('.pc-shared-cart-toast');
 if(!el){
  el=document.createElement('aside');el.className='pc-shared-cart-toast';el.setAttribute('role','status');el.setAttribute('aria-live','polite');
  var close=document.createElement('button');close.type='button';close.className='pc-shared-cart-close';close.setAttribute('aria-label','Close cart summary');close.textContent='×';
  close.addEventListener('click',function(){el.classList.remove('is-open')});
  var title=document.createElement('h2');title.className='pc-shared-cart-title';title.textContent='✓ Added to Cart';
  var n=document.createElement('div');n.className='pc-shared-cart-row';n.innerHTML='<span>Products in bag</span><strong data-shared-cart-count></strong>';
  var p=document.createElement('div');p.className='pc-shared-cart-row';p.innerHTML='<span>Subtotal</span><strong data-shared-cart-total></strong>';
  var link=makeLink('View Shopping Bag →','/cart');link.className='pc-shared-cart-checkout';link.setAttribute('data-shared-cart-link','');
  el.append(close,title,n,p,link);document.body.appendChild(el);
  document.addEventListener('keydown',function(e){if(e.key==='Escape')el.classList.remove('is-open')});
 }
 el.querySelector('.pc-shared-cart-title').textContent=removed?'Removed from Cart':'✓ Added to Cart';
 el.querySelector('[data-shared-cart-count]').textContent=String(count);
 el.querySelector('[data-shared-cart-total]').textContent=money(total);
 el.querySelector('[data-shared-cart-link]').href=real?'/cart':'/cart?preview_theme_id='+themeId;
 el.classList.add('is-open');
}
function uniformButtons(){
 document.querySelectorAll('[data-pc-preview-add],[data-pc-pvc-add],[data-pc-wpc-card-add],[data-pc-pvc-card-add],[data-pc-shower-card-add],[data-pc-shower-add],[data-pc-acoustic-card-add],[data-pc-acoustic-add]').forEach(function(button){
  if(button.dataset.pcSharedObserved)return;
  button.dataset.pcSharedObserved='1';
  var guard=false,normal=function(){
   if(guard)return;var isAdded=/added/i.test(button.textContent),desired=isAdded?'✓ Added to Cart':'Add to Cart →';
   if(button.textContent.trim()!==desired){guard=true;button.textContent=desired;guard=false}
  };
  normal();
  new MutationObserver(normal).observe(button,{subtree:true,childList:true,characterData:true});
 });
}
function realProduct(root){
 var form=root.querySelector('.pc-pdp__form');
 if(!form||form.dataset.pcSharedSubmit)return;
 form.dataset.pcSharedSubmit='1';
 var button=root.querySelector('[data-add]'),label=button&&button.querySelector('[data-add-text]');
 async function getCart(){
  var r=await fetch('/cart.js',{headers:{Accept:'application/json'}});
  if(!r.ok)throw new Error('Unable to check shopping bag');
  return r.json();
 }
 async function sync(){
  try{
   var variant=String(new FormData(form).get('id')||'');
   if(!variant)return;
   var data=await getCart();
   if(label&&!button.disabled)label.textContent=data.items.some(function(item){return String(item.variant_id)===variant;})?'✓ Added to Cart':'Add to Cart';
  }catch(e){}
 }
 form.addEventListener('change',function(){setTimeout(sync,0);});
 sync();
 form.addEventListener('submit',async function(event){
  event.preventDefault();event.stopImmediatePropagation();
  if(button&&button.disabled)return;
  if(button)button.disabled=true;
  var state=root.querySelector('.pc-shared-copy-status');
  try{
   var data=new FormData(form),variant=String(data.get('id')||'');
   if(!variant)throw new Error('Please select a product variant');
   var before=await getCart(),matching=before.items.filter(function(item){return String(item.variant_id)===variant;});
   var removing=matching.length>0;
   if(label)label.textContent=removing?'Removing…':'Adding…';
   if(removing){
    for(var i=0;i<matching.length;i++){
     var resp=await fetch('/cart/change.js',{method:'POST',headers:{Accept:'application/json','Content-Type':'application/json'},body:JSON.stringify({id:matching[i].key,quantity:0})});
     if(!resp.ok){var error=await resp.json();throw new Error(error.description||error.message||'Unable to remove product');}
    }
   }else{
    var reply=await fetch('/cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:data});
    if(!reply.ok){var response=await reply.json();throw new Error(response.description||response.message||'Unable to add product');}
   }
   var after=await getCart();
   toast(after.item_count,after.total_price/100,true,removing);
   if(label)label.textContent=removing?'Add to Cart':'✓ Added to Cart';
   if(state)state.textContent=removing?'Product removed from your Shopping Bag':'';
  }catch(e){
   if(state)state.textContent=String(e.message||'Unable to update Shopping Bag');
   if(label)label.textContent='Add to Cart';
  }finally{if(button)button.disabled=false;}
 },true);
}
function boot(){
 createUI();
 mountFavouritesHeader();
 document.querySelectorAll('[data-pc-wpc-detail],[data-pc-pvc-detail],[data-pc-shower-detail],[data-pc-acoustic-detail],[data-pc-pdp]').forEach(function(root){productActions(root);if(root.matches('[data-pc-pdp]'))realProduct(root)});
 uniformButtons();
 if(!document.documentElement.dataset.pcSharedCartListener){
  document.documentElement.dataset.pcSharedCartListener='true';
  var previous=items();
  document.addEventListener('pc:preview-cart-changed',function(){
   var a=items();
   var removed=a.reduce(function(n,x){return n+x.qty},0)<previous.reduce(function(n,x){return n+x.qty},0);
   previous=a;
   toast(a.reduce(function(n,x){return n+x.qty},0),a.reduce(function(n,x){return n+x.qty*x.price},0),false,removed);
  });
 }
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
document.addEventListener('shopify:section:load',boot);
})();
